import _ from 'underscore';

export const globalizationModelSetup = ({ permissions = {}, culture }) => {
  const {
    IsSimplifiedChineseLanguageEnabledInMultipleLanguage,
    IsDomesticSimplifiedChineseEnabled,
  } = permissions;

  const GA_CURRENCIES = ['ARS', 'AUD', 'BRL', 'CAD', 'CHF', 'CLP', 'CNY', 'COP', 'EUR', 'GBP', 'HKD', 'INR', 'JPY', 'MXN', 'NZD', 'PEN', 'PHP', 'PLN', 'SEK', 'SGD', 'USD', 'VEF', 'DKK', 'TWD', 'TRY', 'ZAR', 'ALL', 'BAM', 'ISK', 'MKD', 'RSD', 'AED', 'ILS', 'SAR', 'NGN', 'IDR', 'MYR', 'THB', 'VND'];
  const GA_LANGUAGES = ['English', 'German', 'French', 'Spanish', 'Italian', 'Japanese', 'Portuguese', 'Dutch', 'Swedish', 'TraditionalChinese', 'Danish', 'Finnish', 'Norwegian', 'Bulgarian', 'Croatian', 'Czech', 'Estonian', 'Greek', 'Hungarian', 'Latvian', 'Lithuanian', 'Maltese', 'Polish', 'Romanian', 'Slovak', 'Slovenian', 'Albanian', 'Bosnian', 'Icelandic', 'Macedonian', 'Serbian', 'Turkish', 'Arabic', 'Russian', 'Hebrew',
    'Hindi', 'Malay', 'Thai', 'Indonesian', 'Tagalog',
    'Vietnamese'];
  const GLOBALIZATION_CH_LANGUAGES = ['SimplifiedChinese'];
  const GA_COUNTRIES = ['AD', 'AL', 'AR', 'AT', 'AU', 'AW', 'BA', 'BD', 'BG', 'BN', 'BO', 'BR', 'BS', 'CA', 'CH', 'CL', 'CO', 'CR', 'CY', 'CZ', 'DE', 'DK', 'DM', 'DO', 'EC', 'EE', 'ES', 'FI', 'FJ', 'FR', 'GB', 'GF', 'GR',
    'GT', 'GU', 'GY', 'HK', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IN', 'IS', 'IT', 'JP', 'KY', 'LI', 'LK', 'LT', 'LU', 'LV', 'MC', 'ME', 'MK', 'MN', 'MQ', 'MS', 'MT', 'MV', 'MX', 'MY', 'NC', 'NL', 'NO', 'NP', 'NZ', 'PA', 'PE',
    'PF', 'PG', 'PH', 'PL', 'PR', 'PT', 'PY', 'RO', 'RS', 'SE', 'SG', 'SI', 'SK', 'SM', 'SV', 'TH', 'TR', 'TT', 'TW', 'US', 'UY', 'VA', 'VE', 'VN', 'ZA', 'CD', 'ET', 'GN', 'LS', 'MG', 'MW', 'MR', 'MU', 'NA', 'NG', 'RE', 'SC',
    'TZ', 'GM', 'TG', 'ZW', 'DZ', 'AM', 'AZ', 'BH', 'EG', 'GE', 'IQ', 'IL', 'KG', 'LY', 'MD', 'OM', 'PK', 'QA', 'SA', 'TJ', 'AE', 'YE',
    'CM', 'CG', 'CI', 'RW', 'SN', 'SO', 'UG', 'ZM', 'BW', 'GA', 'TN', 'BJ', 'BF', 'NE', 'AS', 'AI', 'BM', 'VG', 'GI', 'MP', 'TC', 'VI', 'BB', 'BZ', 'GD', 'JM', 'MH', 'KN', 'LC', 'VC', 'SR', 'TO', 'GL', 'FO',
    'AG', 'CC', 'CF', 'CK', 'CX', 'DJ', 'ER', 'GP', 'GW', 'KM', 'NF', 'NR', 'NU', 'PM', 'PN', 'PW', 'SL', 'TK', 'TV', 'VU', 'WF', 'WS', 'YT', 'MO', 'BE'];

  const alphabeticalComparer = new Intl.Collator(culture).compare;

  let LANGUAGES = [];
  if (IsDomesticSimplifiedChineseEnabled) {
    LANGUAGES = [...GLOBALIZATION_CH_LANGUAGES];
  } else {
    LANGUAGES = _.uniq([
      ...GA_LANGUAGES,
      ...IsSimplifiedChineseLanguageEnabledInMultipleLanguage ? GLOBALIZATION_CH_LANGUAGES : [],
    ].sort(alphabeticalComparer));
  }

  const CURRENCIES = [
    ...GA_CURRENCIES,
  ].sort(alphabeticalComparer);

  const COUNTRIES = [
    ...GA_COUNTRIES,
  ];

  return {
    LANGUAGES,
    CURRENCIES,
    COUNTRIES,
  };
};
